﻿/// <reference path="../@types/data-tables/types.d.ts" />
import { data } from "jquery";
import { global } from "../Common/saop-common";
import { SaopTranslationService } from '../Core/saop-translate';
import { SaopMessageDlg, SaopMsgDlgButton } from "./saop-message-dlg";

export class SaopTreeview {
    private _viewId: string;
    private libName: string;  
    private _translationService: SaopTranslationService;

    constructor(viewId: string, libName: string) {
        this._viewId = viewId;
        this.libName = libName;
        this._translationService = new SaopTranslationService();
    }  

    init() {
        global.ConsoleLogDegug("SaopTreeview.init");
        // prevajanje
        this.setFormTerminologyList();

        this.initEventListners();

        this.initSortable();
        this.togglePasteButtonVisibility();
    }

    private setFormTerminologyList() {
        global.ConsoleLogDegug("SaopTreeview.setFormTerminologyList");

        let terminology = ["Ni podatkov za prikaz.", "Brisanje", "Ali ste prepričani, da želite izbrisati element?"];
        this._translationService.setTranslationsList(terminology);
    }

    private initEventListners() {
        global.ConsoleLogDegug("SaopTreeview.initEventListners");
        let _this = this;

        $(this._viewId).off("click", ".saop-treeview-expand-colapse"); 
        $(this._viewId).on("click", ".saop-treeview-expand-colapse", function (event) {
            global.ConsoleLogDegug("SaopTreeview.saop-treeview-expand-colapse.click");

            event.stopPropagation();
            _this.treeviewExpandColapse(this);
        });

        $(this._viewId).off("click", ".saop-treeview-item-delete");
        $(this._viewId).on("click", ".saop-treeview-item-delete", function (event) {
            global.ConsoleLogDegug("SaopTreeview.saop-treeview-item-delete.click");

            event.stopPropagation();
            _this.deleteTreeviewItem(this);
        });

        $(this._viewId).off("click", ".saop-treeview-item-addSubItem");
        $(this._viewId).on("click", ".saop-treeview-item-addSubItem", function (event) {
            global.ConsoleLogDegug("SaopTreeview.saop-treeview-item-addSubItem.click");

            event.stopPropagation();
            _this.addTreeviewSubItem(this);
        });

        $(this._viewId).off("click", ".saop-treeview-item-insertItem");
        $(this._viewId).on("click", ".saop-treeview-item-insertItem", function (event) {
            global.ConsoleLogDegug("SaopTreeview.saop-treeview-item-insertItem.click");

            event.stopPropagation();
            _this.insertItem(this);
        });
        $(this._viewId).off("click", ".saop-treeview-item-edit");
        $(this._viewId).on("click", ".saop-treeview-item-edit", function (event) {
            global.ConsoleLogDegug("SaopTreeview.saop-treeview-item-edit.click");

            event.stopPropagation();
            _this.editTreeviewItem(this);
        });

        $(this._viewId).off("click", ".saop-treeview-add-item-btn");
        $(this._viewId).on("click", ".saop-treeview-add-item-btn", function (event) {
            global.ConsoleLogDegug("SaopTreeview.saop-treeview-add-item-btn.click");

            event.stopPropagation();
            _this.addTreeviewItem(this);
        });
        $(this._viewId).off("click", ".saop-treeview-checkbox");
        $(this._viewId).on("click", ".saop-treeview-checkbox", function (event) {
            event.stopPropagation();
        });

        $(this._viewId).off("change", ".saop-treeview-checkbox");
        $(this._viewId).on("change", ".saop-treeview-checkbox", function (event) {
            event.stopPropagation();
            _this.toggleTreeviewChildrenCheckboxes(this);

            if ($(this).prop("checked")) {
                _this.checkPathToSelectedParent(this);
             }
            _this.checkboxSelectionChangedExternal();
        });

        $(this._viewId).off("click",'.saop-btn-paste-root');
        $(this._viewId).on('click', '.saop-btn-paste-root', (e) => {

            e.stopPropagation();
            this.pasteTreeviewItemExternal(null);
        });

        $(this._viewId).off("click",'.saop-treeview-item-paste');
        $(this._viewId).on("click", ".saop-treeview-item-paste", function (e) {
            e.stopPropagation();

            const id = $(this).closest(".saop-treeview-item").attr("data-id");
            _this.pasteTreeviewItemExternal(id ? Number(id) : null);
        });
    }
    private toggleTreeviewChildrenCheckboxes(elem: HTMLElement): void {
        const $checkbox = $(elem);
        const checked = $checkbox.prop("checked");
        const $item = $checkbox.closest(".saop-treeview-item");

        $item.find(".saop-treeview-sortable .saop-treeview-checkbox").prop("checked", checked);
    }
    private checkPathToSelectedParent(elem: HTMLElement): void {
        const $item = $(elem).closest(".saop-treeview-item");
        const $parents = $item.parents(".saop-treeview-item");

        let selectedParentIndex = -1;

        $parents.each(function (index) {
            const checked = $(this).children(".saop-treeview-control-show-source")
                .find(".saop-treeview-checkbox").first().prop("checked");

            if (checked) {
                selectedParentIndex = index;
                return false;
            }
        });

        if (selectedParentIndex === -1)
            return;

        $parents.slice(0, selectedParentIndex).each(function () {
            $(this)
                .children(".saop-treeview-control-show-source")
                .find(".saop-treeview-checkbox")
                .first()
                .prop("checked", true);
        });
    }

    public checkboxSelectionChangedExternal(): void {}
    public pasteTreeviewItemExternal: (targetId: number | null) => void = () => {};
    public hasSelectedTreeviewItems(): boolean {
        return $(this._viewId).find(".saop-treeview-checkbox:checked").length > 0;
    }
    
    
    private getSelectedElementIds(): number[] {
        const ids: number[] = [];
        $(this._viewId).find(".saop-treeview-checkbox:checked").each(function () {
            const id = $(this).closest(".saop-treeview-item").attr("data-id");
            if (id)
                ids.push(Number(id));
        });
        return ids;
    }
    public getSelectedTreeviewItemsHtml(): any[] {
        const ids = new Set(this.getSelectedElementIds());

        if (ids.size === 0)
            return [];

        const items: any[] = [];

        $(this._viewId).find(".saop-treeview-checkbox:checked").closest(".saop-treeview-item").each(function () {
            const $item = $(this);
            const id = Number($item.attr("data-id"));

            const hasSelectedParent = $item.parents(".saop-treeview-item").filter(function () {
                return ids.has(Number($(this).attr("data-id")));
            }).length > 0;

            if (hasSelectedParent)
                return;

            const $clone = $item.clone();

            $($clone.find(".saop-treeview-item").get().reverse()).each(function () {
                const $child = $(this);
                const childId = Number($child.attr("data-id"));

                if (!ids.has(childId))
                    $child.closest(".saop-treeview-item-container").remove();
            });

            $clone.find(".saop-treeview-item").addBack(".saop-treeview-item").each(function () {
                const $treeItem = $(this);
                const hasChildren = $treeItem.children(".saop-treeview-sortable").children(".saop-treeview-item-container").length > 0;

                if (!hasChildren)
                    $treeItem.find(".saop-treeview-expand-colapse").first().hide();
            });

            $clone.find(".saop-treeview-checkbox").prop("checked", false).removeAttr("checked");
            $clone.find(".saop-treeview-item-selected").addBack(".saop-treeview-item-selected").removeClass("saop-treeview-item-selected");

            items.push({
                id: id,
                html: $clone.prop("outerHTML")
            });
        });

        return items;
    }

    private treeviewExpandColapse(elem: any): void {
        global.ConsoleLogDegug("SaopTreeview.treeviewExpandColapse");

        let id = $(elem).attr("data-toogleelementsid");
        let collapseItems = $(elem).hasClass("saop-img-down");

        $(elem).toggleClass("saop-img-down");
        $(elem).toggleClass("saop-img-right");

        // show/hide
        $(this._viewId + " div.saop-treeview-item-container[data-parentid='" + id + "']").each(function (index: number, childElem: any) {
            if (collapseItems) {
                $(childElem).hide("fast");
            }
            else {
                $(childElem).show("fast");
            }
        });    
    }

    private deleteTreeviewItem(elem: HTMLElement): void {
        global.ConsoleLogDegug("SaopTreeview.deleteTreeviewItem");

        let _this = this;
        let deleteTitle = this._translationService.translate("Brisanje");
        let deleteMessage = this._translationService.translate("Ali ste prepričani, da želite izbrisati element?");

        let saopMessageDlg = new SaopMessageDlg(null);
        saopMessageDlg.onYes = function () {
            // poiscemo parent z klasom saop-treeview-item-container in ga odstranimo ter vse childreen
            let tempElement = elem;
            let parentid = 0;
            for (var i = 0; i < 10; i++) {
                if (tempElement.classList.contains("saop-treeview-item-container")) {
                    parentid = global.convertString2Number(tempElement.getAttribute("data-parentid"));
                    // odstranimo element
                    tempElement.innerHTML = ""; 
                    tempElement.remove();
                    break;
                }
                tempElement = tempElement.parentElement;
            }
            if (parentid != null && parentid > 0) {
                // ali je se kaj ostalih child elementov z istim parentId?
                let childreenCount = $(_this._viewId + ' div.saop-treeview-item-container[data-parentid="' + parentid + '"]').length;
                if (childreenCount == 0) {
                    // zbrisali zadnjega child element, skrijemo expand/collapse ikono parent elementa
                    let parentElement = $(_this._viewId + ' div.saop-treeview-item[data-id="' + parentid + '"]');
                    if (parentElement != null) {
                        let expandCollapseElem = $(parentElement).find(".saop-treeview-expand-colapse");
                        if (expandCollapseElem != null) {
                            expandCollapseElem.hide();
                        }
                    }
                }
            }
        };
        saopMessageDlg.Show(deleteMessage, deleteTitle, 1, [SaopMsgDlgButton.mbYes, SaopMsgDlgButton.mbNo]);
    }

    private addTreeviewSubItem(addSubItemButtonElement: HTMLElement): void {
        global.ConsoleLogDegug("SaopTreeview.addTreeviewSubItem");
        // iscemo podatke prejsnjega, za predlaganje podatkov
        let idPrevious = this.getReferenceElementId(addSubItemButtonElement, true);

        // prikazemo expand/collapse ikono:
        // poiscemo parent, ki ima klas saop-treeview-item-info,
        let parentElem = addSubItemButtonElement.parentElement;
        for (var i = 0; i < 10; i++) {
            if (parentElem.classList.contains("saop-treeview-item-info")) {
                // poiscemo njegov child, ki ima klas saop-treeview-expand-colapse
                let expandCollapseElem = $(parentElem).find(".saop-treeview-expand-colapse");
                if (expandCollapseElem != null) {
                    expandCollapseElem.show();
                }
                break;
            }
            parentElem = parentElem.parentElement;
        }

        // poisci max Id Treeviews in ga povecamo za 1
        let newSubItemId = this.getMaxTreeviewId() + 1;
        // parent Id
        let newSubItemParentId = global.convertString2Number($(addSubItemButtonElement).attr("data-parentid"));

        this.addTreeviewSubItemExternal(addSubItemButtonElement, newSubItemId, newSubItemParentId, idPrevious);
    }

    public getMaxTreeviewId(): number {
        global.ConsoleLogDegug("SaopTreeview.getMaxTreeviewId");

        let maxId = 0

        $(this._viewId + " .saop-treeview-item").each(function (index, htmlTreeviewItem) {
            let id = global.convertString2Number(htmlTreeviewItem.getAttribute("data-id"));
            if (id != null && id > maxId) {
                maxId = id;
            }
        });

        return maxId;
    }

    public addTreeviewSubItemExternal(addSubItemButtonElement: HTMLElement, newSubItemId: number, newSubItemParentId: number, idPrevious?: number | null): void {
        global.ConsoleLogDegug("SaopTreeview.addTreeviewSubItemExternal");
    }

    // metodo uporablja client, vrne content, ki jo dodamo v treeview
    public addTreeviewSubItemContent(addSubItemButtonElement: HTMLElement, newSubItemId: number, newSubItemParentId: number, htmlContent: string): void {
        global.ConsoleLogDegug("SaopTreeview.addTreeviewSubItemContent");

        let elemParent = $(this._viewId + ' div.saop-treeview-item[data-id="' + newSubItemParentId + '"]');
        elemParent.append(htmlContent);
    }

    private addTreeviewItem(addItemButtonElement: HTMLElement): void {
        global.ConsoleLogDegug("SaopTreeview.addTreeviewItem");
        // poisci max Id Treeviews in ga povecamo za 1
        let newItemId = this.getMaxTreeviewId() + 1;

        this.addTreeviewItemExternal(addItemButtonElement, newItemId, null);
    }

    public addTreeviewItemExternal(addItemButtonElement: HTMLElement, newItemId: number, newItemParentId: number): void {
        global.ConsoleLogDegug("SaopTreeview.addTreeviewItemExternal");
    }

    // metodo uporablja client, vrne content, ki jo dodamo v treeview
    public addTreeviewItemContent(addItemButtonElement: HTMLElement, newItemId: number, newItemParentId: number, htmlContent: string): void {
        global.ConsoleLogDegug("SaopTreeview.addTreeviewItemContent");

        // odstranimo add item html, ker ga bo ze dodal htmlContent
        $(this._viewId + " .saop-treeview-add-item-container").each(function (index, htmlTreeviewAddItem) {
            htmlTreeviewAddItem.remove();
        });

        let elemParent = $(this._viewId);
        elemParent.append(htmlContent);
    }

    private editTreeviewItem(elem: HTMLElement): void {
        global.ConsoleLogDegug("SaopTreeview.editTreeviewItem");

        // odstranimo css klas za obrobo vsem elementom in jo dodamo izbranemu
        this.clearTreeviewItemsSelectedCss();
        $(elem).addClass("saop-treeview-item-selected");

        elem.focus();

        this.editTreeviewItemExternal(elem);
    }

    // za externo uporabo
    public editTreeviewItemExternal(elem: HTMLElement): void {
        global.ConsoleLogDegug("SaopTreeview.editTreeviewItemExternal");
    }

    public clearTreeviewItemsSelectedCss(): void {
        global.ConsoleLogDegug("SaopTreeview.clearTreeviewItemsSelectedCss");

        $(this._viewId + " .saop-treeview-item-info").removeClass("saop-treeview-item-selected");
    }

    // elem je isti kot ga ponuja editTreeviewItem oz. editTreeviewItemExternal
    public refreshTreeviewItemHeader(elem: HTMLElement, header: string): void {
        global.ConsoleLogDegug("SaopTreeview.refreshTreeviewItemHeader");

        $(elem).find(".saop-treeview-item-header").text(header);
    }

    private insertItem(insertItemButtonElement: HTMLElement): void {
        global.ConsoleLogDegug("SaopTreeview.insertItem");
        // poiscemo parent, ki ima klas saop-treeview-item-container,
        let parentFound = false
        let parentElem = insertItemButtonElement.parentElement;
        for (var i = 0; i < 20; i++) {
            if (parentElem.classList.contains("saop-treeview-item-container")) {
                parentFound = true;
                break;
            }
            parentElem = parentElem.parentElement;
        }
        if (parentFound) {
            // poisci max Id Treeviews in ga povecamo za 1
            let newItemId = this.getMaxTreeviewId() + 1;
            // parentId
            let newItemParentId = global.convertString2Number($(parentElem).attr("data-parentid"));
            // iscemo podatke prejsnjega, za predlaganje podatkov
            let idPrevious = this.getReferenceElementId(insertItemButtonElement, false);


            this.insertTreeviewItemExternal(parentElem, newItemId, newItemParentId, idPrevious);
        }   
    }

    public insertTreeviewItemExternal(itemToAppendTo: HTMLElement, newItemId: number, newItemParentId: number, idPrevious?: number | null): void {
        global.ConsoleLogDegug("SaopTreeview.insertTreeviewItemExternal");
    }

    public insertTreeviewItemContent(itemToAppendTo: HTMLElement, newItemId: number, newItemParentId: number, htmlContent: string): void {
        global.ConsoleLogDegug("SaopTreeview.insertTreeviewItemContent");

        $(itemToAppendTo).after(htmlContent);
    }

    public initSortable(): void {
        global.ConsoleLogDegug("SaopTreeview.initSortable");

        if (!($.fn as any).andSelf) { ($.fn as any).andSelf = ($.fn as any).addBack; }

        let sortableContainers = $(this._viewId).find(".saop-treeview-sortable");

        if (sortableContainers.length > 0) {
            (sortableContainers as any).sortable({
                handle: ".drag-handle",
                axis: "y",
                cursor: "grabbing",
                opacity: 0.7
            });

            (sortableContainers as any).disableSelection();
        }
    }

    public togglePasteButtonVisibility(): void {
        const hasData = localStorage.getItem('saop_treeview_copy_buffer') !== null;
        const $buttons = $('.saop-btn-paste-root');
        const $pasteButtons = $('.saop-treeview-item-paste');

        if (hasData) {
            $buttons.fadeIn(200); 
            $pasteButtons.css('display', '');
        } else {
            $buttons.hide();
            $pasteButtons.css('display', 'none');
        }
    }

    private getReferenceElementId(clickedElement: HTMLElement, isSubItem: boolean): number | null {
        let $btn = $(clickedElement);

        if (isSubItem) {
            let parentId = global.convertString2Number($btn.attr("data-parentid"));
            
            let $childrenContainer = $('#sortable-treeview-' + parentId);

            let $lastChild = $childrenContainer.children('.saop-treeview-item-container').last();

            if ($lastChild.length > 0) {
                let targetId = $lastChild.find('.saop-treeview-item').first().attr('data-id');
                return targetId ? parseInt(targetId, 10) : null;
            } else {
                return parentId;
            }
        } 
        else {
            let currentElementId = $btn.closest('.saop-treeview-item').attr('data-id');
            return currentElementId ? parseInt(currentElementId, 10) : null;
        }
    }
    public uncheckAllTreeviewItems(): void {
        $(this._viewId).find(".saop-treeview-checkbox").prop("checked", false);
        this.checkboxSelectionChangedExternal();
    }

}






